import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsAskMeAnythingEnabled = () => boolean;
export const useIsAskMeAnythingEnabled: UseIsAskMeAnythingEnabled = () => {
  const isVivaEngagePremiumEnabled = useExperimentTreatmentWithoutReporting('VivaEngagePremium') === true;

  return isVivaEngagePremiumEnabled;
};
